export default "__VITE_ASSET__SALOJHFP__"